// 兼容vuex方法
import { mapState as piniaMapState } from 'pinia';
import { useIndexStore } from '~/store/index';
export const isElementPlus = true;
export const mapState = (states: any, store = useIndexStore) => piniaMapState(store, states);

export const usePatchStore = () => {
  // const storeMap = computed<Record<string, any>>(() => ({
  //     index: useIndexStore,
  //     account: useAccountStore,
  //     trade: useTradeStore,
  //     margin: useMarginStore,
  //   }));
  const dispatch = (state: string, params: any = undefined) => {
    const indexStore = useIndexStore()
    const paths = state.split('/');
    if (paths.length > 1) {
      const store = indexStore?.[paths[0]] || indexStore;
      return store[paths[1]] && store[paths[1]](params);
    } else {
      return indexStore[state] && indexStore[state](params);
    }
  };
  const commit = (state: string, params: any) => {
    const indexStore = useIndexStore()
    const paths = state.split('/');
    if (paths.length > 1) {
      const store = indexStore?.[paths[0]] || indexStore;
      store[paths[1]] && store[paths[1]](params);
    } else {
      indexStore[state] && indexStore[state](params);
    }
  };
  const getters = (state: string) => {
    const indexStore = useIndexStore()
    const paths = state.split('/');
    if (paths.length > 1) {
      const store = indexStore?.[paths[0]] || indexStore;
      return store[paths[1]];
    } else {
      return indexStore[state];
    }
  };
  const proxyStore = new Proxy(
    {},
    {
      get: function (target, propKey, receiver) {
        if (propKey === 'getters') {
          return new Proxy(
            {},
            {
              get: function (target, propKey: string, receiver) {
                return getters(propKey);
              },
            }
          );
        } else if (propKey === 'commit') {
          return commit;
        } else if (propKey === 'dispatch') {
          return dispatch;
        } else if (propKey === 'state') {
          return useIndexStore();
        }
        return useIndexStore()[propKey];
      },
    }
  )
  return { dispatch, commit, getters, store: proxyStore || {} };
};

export const useStore = function () {
  const { store } = usePatchStore();
  // return new Proxy({}, {
  //     get: function (target, propKey, receiver) {
  //       if (propKey === "getters") {
  //         return new Proxy(
  //           {},
  //           {
  //             get: function (target, propKey, receiver) {
  //               const paths = (propKey as string).split("/");
  //               if (paths.length > 1) {
  //                 const store = storeMap[paths[0]]?.() || useIndexStore();
  //                 return store[paths[1]]
  //               } else {
  //                 return useIndexStore()[propKey];
  //               }
  //             },
  //           }
  //         );
  //       }
  //       return useIndexStore();
  //     },
  //   }
  // );
  return store;
};
